import * as React from 'react';
import { Page } from '~/components/about-bs-page/about-bs-page';

const AboutBSPage: React.FC = () => <Page />;

export default AboutBSPage;
